import React from 'react';
import { ReactComponent as Calendar } from 'assets/icons/calendar-icon.svg';

export const CustomDateInput = React.forwardRef(
  ({ value, onClick, onChange, onBlur }, ref) => {
    return (
      <input
        type='text'
        ref={ref}
        value={value || ''}
        onClick={onClick}
        onChange={onChange}
        onBlur={onBlur}
        placeholder='Date'
        onKeyDown={(e) => {
          const allowed = /^[0-9/]$/;
          if (
            !allowed.test(e.key) &&
            e.key !== 'Backspace' &&
            e.key !== 'ArrowLeft' &&
            e.key !== 'ArrowRight' &&
            e.key !== 'Tab'
          ) {
            e.preventDefault();
          }
        }}
      />
    );
  },
);

export const CustomDatePickerInput = React.forwardRef(
  ({ value, onClick }, ref) => (
    <div
      className='management-datepicker'
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      role='button'
      tabIndex={0}
    >
      <input
        type='text'
        ref={ref}
        value={value || ''}
        readOnly
        placeholder='Select a date'
      />
      <Calendar className='svg-icon' />
    </div>
  ),
);
